import { FC } from 'react';
import { AdvertServiceDataType } from '@edikk-edikk/country-frontend';
import modelDetailParameterCss from '#advertDetail/assets/model-detail/model-detail-parameter.module.scss';

type PropsType = {
  serviceData: AdvertServiceDataType;
};

const ServiceComment: FC<PropsType> = ({
  serviceData,
}) => {
  if (!serviceData.comment) {
    return null;
  }

  return (
    <div className={modelDetailParameterCss.modelDetailParameter__comment}>
      {serviceData.comment}
    </div>
  );
};

export { ServiceComment };
